import { cartApi } from '@/api'

const state = {
  items: [],
  subtotal: 0,
  count: 0,
  loading: false,
  drawerOpen: false,
}

const getters = {
  cartItems: (s) => s.items,
  cartCount: (s) => s.count,
  cartSubtotal: (s) => s.subtotal,
  isDrawerOpen: (s) => s.drawerOpen,
}

const mutations = {
  SET_CART(state, { items, subtotal, count }) {
    state.items = items || []
    state.subtotal = subtotal || 0
    state.count = count || 0
  },
  SET_LOADING(state, val) { state.loading = val },
  SET_DRAWER(state, val) { state.drawerOpen = val },
}

const actions = {
  async fetch({ commit }) {
    if (!localStorage.getItem('token')) return
    commit('SET_LOADING', true)
    try {
      const { data } = await cartApi.get()
      commit('SET_CART', data)
    } catch (_) {
      commit('SET_CART', { items: [], subtotal: 0, count: 0 })
    } finally {
      commit('SET_LOADING', false)
    }
  },
  async addItem({ dispatch }, { itemId, quantity = 1 }) {
    await cartApi.add(itemId, quantity)
    await dispatch('fetch')
  },
  async updateQuantity({ dispatch }, { cartItemId, quantity }) {
    await cartApi.update(cartItemId, quantity)
    await dispatch('fetch')
  },
  async removeItem({ dispatch }, cartItemId) {
    await cartApi.remove(cartItemId)
    await dispatch('fetch')
  },
  async clear({ dispatch }) {
    await cartApi.clear()
    await dispatch('fetch')
  },
  toggleDrawer({ commit, state }) {
    commit('SET_DRAWER', !state.drawerOpen)
  },
}

export default { namespaced: true, state, getters, mutations, actions }
